import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import countries from '../../../assets/json/countries.json';
import { Country } from '../../models/country.models';
import { EstablishmentService } from '../../services/establishment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FlagService } from '../../shared/services/flag.service';
import { FlagType } from '../../shared/utils/enums';
import { StrongPasswordRegx } from '../../shared/utils/data/shared.data';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-etablissement',
  templateUrl: './etablissement.component.html',
  styleUrl: './etablissement.component.scss',
})
export class EtablissementComponent implements OnInit {
  step: number = 1; // init 1
  loading = false;

  firstStepFormControl: FormGroup = this.fb.group({
    id: 95,
    isYourEstablishmentHasMoreThanOneSite: true,
    prefixe: ['', Validators.required],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    password: [
      '',
      [Validators.required, Validators.pattern(StrongPasswordRegx)],
    ],
    confirmBtn: ['', Validators.required],
  });

  secondStepFormControl: FormGroup = this.fb.group({
    name: ['', Validators.required],
    numsiret: [
      '',
      [Validators.required, Validators.minLength(14), Validators.maxLength(14)],
    ],
    typeetablissement: ['', Validators.required],
    nombresalaries: [''],
    numfiness: ['', [Validators.minLength(9), Validators.maxLength(9)]],
    nombreannuelpatients: [''],
    description: [''],
    platformManagedBy: [''],
  });

  thirdStepFormControl: FormGroup = this.fb.group({
    adresses: this.fb.array([]),
  });
  finalStepFormGroup: FormGroup = this.fb.group({
    persons: this.fb.array([]),
  });

  phoneSelected: any[] = [];
  countriesList: Country[] = countries;

  addressForm = this.fb.group({
    name: ['', Validators.required],
    adress: ['', Validators.required],
    address: [''],
    pays: ['', Validators.required],
    codePostale: ['', Validators.required],
    regionCode: ['', Validators.required],
    regionName: ['', Validators.required],
    ville: ['', Validators.required],
    departmentName: ['', Validators.required],
    addressImages: [[]],
    cededx: [''],
    firstPhoto: [''],
    secondPhoto: [''],
    lat: [<number | null>null],
    lon: [<number | null>null],
  });

  contactForm = this.fb.group({
    civility: [''],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    fonction: ['', Validators.required],
    mail: ['', [Validators.required, Validators.email]],
    numTel: ['', Validators.required],
    title: [''],
    photo1: [''],
    photo2: [''],
  });
  type: string | null;
  constructor(
    private fb: FormBuilder,
    private establishmentService: EstablishmentService,
    private flag: FlagService,
    private route: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService
  ) {
    this.adressesControl.push(this.addressForm);
    // this.contacts.push(this.contactForm)
  }

  get contacts(): FormArray {
    return this.finalStepFormGroup.get('persons') as FormArray;
  }

  ngOnInit(): void {
    this.type = this.route.snapshot.paramMap.get('type');
    this.finalStepFormGroup
      .get('finalStepForm')
      ?.valueChanges.subscribe((value) => {
        value.map((el: any, key: number) => {
          value[key].phoneNumber =
            value[key].phoneIsoCode + value[key].phoneNumber;
          let icon = this.countriesList
            .find((el) => el.num_code == value[key].phoneIsoCode)
            ?.alpha_2_code.toLocaleLowerCase();
          icon = 'assets/icons/flag/' + icon + '.svg';
          this.phoneSelected[key] = {
            phoneIsoCode: value[key].phoneIsoCode,
            icon: icon,
          };
        });
      });
  }

  addNewSite() {
    // this.siteData.push(this.newFormData())
  }

  get adressesControl(): FormArray {
    return this.thirdStepFormControl.get('adresses') as FormArray;
  }

  removeNewSite(index: any): void {
    const control = <FormArray>this.thirdStepFormControl.controls['form'];
    control.removeAt(index, { emitEvent: false });
  }

  removeNewContact(index: any): void {
    const control = <FormArray>(
      this.finalStepFormGroup.controls['finalStepForm']
    );
    control.removeAt(index, { emitEvent: false });
  }

  onSubmit(): any {
    if (this.step < 4) {
      this.step++;
    } else {
      this.loading = true;
      if (this.type == 'etablissement') {
        const finalBody = {
          ...this.firstStepFormControl.value,
          ...this.secondStepFormControl.value,
          ...this.thirdStepFormControl.value,
          ...this.finalStepFormGroup.value,
        };

        finalBody.fullname = finalBody.firstName + ' ' + finalBody.lastName;

        finalBody.persons.map((a: any) => {
          
          const item = a;
          item.numTel = a?.numTel?.number;
          item.fullnamepersonnecontact = a?.firstName + ' ' + a?.lastName;
          item.fonctionpersonnecontact = a?.fonction;
          return item;
        });

        this.establishmentService
          .updateEstablishment(finalBody, finalBody.id)
          .subscribe({
            next: (res) => {
              this.flag.displayFlag(
                'Compte établissement crée avec succés !',
                FlagType.success
              );
              localStorage.setItem('establishment', JSON.stringify(res));
              localStorage.setItem('id', res?.id);
              this.router.navigate(['dashboard/accueil']);
            },
            error: (err) => {
              console.log(err);
              this.flag.displayFlag(
                'Veuillez compléter les informations manquantes. ',
                FlagType.error
              );
              this.loading = false;
            },
            complete: () => (this.loading = false),
          });
      } else {
      }
    }
  }

  onPrevStep(): void {
    if (this.step > 1) {
      this.step--;
    }
  }
}
